import normalizeApiError from '../utils/apiError';

import { engineApi } from './api';

export const getOffers = async (requestId, providers = []) => {
  if (!requestId || !providers.length) {
      return { success: true, data: [] };
  }
  try {
    const { data } = await engineApi.post(`/offers`, { providers, requestId });
    return { success: true, data: data.offers || [] };
  } catch (error) {
    return normalizeApiError(error, {
      context: 'getting offers',
      fallbackMessage: 'No pudimos cargar las ofertas. Intentá nuevamente.'
    });
  }
};
